<template>
	<Slider :sliders="sliders"></Slider>
</template>

<script>
import Slider from "@/components/Pages/CategorySlider";

export default {
	components: { Slider },

	data() {
		return {
			sliders: [
				{
					title: "Esmalte",
					name: "Esmalte 300",
					color: "#3E4596",
					categories: [2, 28],
					img: "/img/esmalte300.png",
					description:
						"Industrial 300 es un esmalte libre de plomo amigable con el medio ambiente de extensa durabilidad que ofrece gran protección impidiendo la formación de corrosión y oxidación, además de prevenir ampliamente el deterioro de materiales como metal, yeso, madera, cemento, concreto, entre otros.",
				},
				{
					title: "Esmalte",
					name: "Tecnobril",
					color: "#BD8327",
					categories: [2, 31],
					img: "/img/tecnobril.png",
					description:
						"Es un esmalte alquidálico con excelente acabado brillante y fácil aplicación. Puede usarse tanto en interiores como exteriores.",
				},
				{
					title: "Esmalte",
					name: "Brilfast",
					color: "#018A45",
					categories: [2, 29],
					img: "/img/brilfast.png",
					description:
						"Es un esmalte alquidálico anticorrosivo brillante creado para proteger y dar mantenimiento a superficies, logrando que permanezcan con un aspecto perfecto y a la vez obtener máxima protección contra agentes externos del ambiente como la humedad y polvo. Su uso es ampliamente recomendado en acero, metal, aplanados, ladrillo, madera, entre otros.",
				},
			],
		};
	},
};
</script>

<style lang="css" scoped></style>
